import { MutationTree } from 'vuex';
import { StudioState } from '@/store/types/studio.state';

export const mutations: MutationTree<StudioState> = {
    setBaseHue(state, value){
        state.baseHue = value;
    },
    setScale(state, value){
        state.scale = value;
    },
    setMode(state, value){
        state.mode = value;
    },
    setSelectedOctave(state, value){
        state.selectedOctave = value;
    },
    setSelectedColor(state, value){
        state.selectedColor = value;
    },
    setBaseNote(state, value){
        state.baseNote = value;
    },
    setScaleNotesArray(state, value){
        state.scaleNotesArray = value;
    },
    setMenuDisplaying(state, value){
        state.menuDisplaying = value;
    },
    addSelectedColor(state, value){
        state.selectedColors.push(value);
    },
    removeSelectedColor(state, value){
        const index = state.selectedColors.indexOf(value);
        state.selectedColors.splice(index, 1);
    }
};
